@if (!isLoginForm) {
    @if (!formLoaded) {
      <app-contact-sales-form-skeleton-loader></app-contact-sales-form-skeleton-loader>
    }
    <form id="mktoForm_4150"></form>
} @else {
  <form id="mktoForm_6515"></form>
}
 <div class="acknowledgement" [ngClass]="{'visible-div': isVisible, 'hidden-div': !isVisible}">
    <h4>{{ ackHeader }}</h4>
    <p [innerHTML]="ackDescription"></p>
    <div class="redirect-button" style="display: none">
        <wpbutton to="/">Back to Developer Hub</wpbutton>
    </div>
</div>